export default {
    setEmployeeFilterFieldsMutation(state, payload)
    {
        state.employeeFilter.fields.employeeId = payload.employee_id;
        state.employeeFilter.main_filter = payload.main_filter;
    },
    setEmployeeList(state, payload)
    {
        state.employeeList = payload;
    },
    setEmployeeListCount(state, payload) {
        state.employeeListCount = payload;
    },
    deleteEmployeesMutation(state, payload)
    {
        if (payload.length) {
            let index = null;

            payload.forEach(function(item, i, payload) {
                document.getElementById(`employee-id-${item}`).checked = false;

                index = state.employeeList.findIndex(employee => employee.id == item);

                if (index !== -1) {
                    state.employeeList.splice(index, 1);
                }
            });
        }
    },
    setEmployeeModalOpenMutation(state, payload)
    {
        state.employeeModalOpen = payload;
    },
    setEmployeeIdAndEmployeeIndexToModalFormMutation(state, payload)
    {
        state.employee_id = payload.employee_id;
        state.employee_index = payload.employee_index;
    },
    addEmployeeToEmployeeList(state, payload)
    {
        state.employeeList.push(payload);
    },
    updateEmployee(state, payload)
    {
        state.employeeList[payload.employee_index].name = payload.name;
        state.employeeList[payload.employee_index].roles = payload.roles;
    },
}
